import { render, staticRenderFns } from "./certificateRectangleSettings.vue?vue&type=template&id=a00a33bc&scoped=true&"
import script from "./certificateRectangleSettings.vue?vue&type=script&lang=js&"
export * from "./certificateRectangleSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a00a33bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VDivider,VExpandTransition})
